var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row-slider"
  }, [_c('div', {
    ref: "slider",
    staticClass: "row-slider__slides"
  }, [_c('div', {
    staticClass: "constructor-swiper-wrapper"
  }, _vm._l(_vm.list, function (el, index) {
    return _c('div', {
      key: index,
      staticClass: "constructor-swiper-slide",
      style: {
        'margin-right': ((_vm.offsetBetweenElements) + "px")
      }
    }, [_vm._t("default", null, {
      "el": el
    })], 2);
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "row-slider__nav"
  }, [_c('button', {
    ref: "buttonPrev",
    staticClass: "row-slider__arrow row-slider__arrow_left",
    class: {
      'row-slider__arrow_hide': _vm.isStart
    }
  }), _vm._v(" "), _c('button', {
    ref: "buttonNext",
    staticClass: "row-slider__arrow row-slider__arrow_right",
    class: {
      'row-slider__arrow_hide': _vm.isEnd
    }
  })])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }